module.exports = __webpack_public_path__ + "img/Felrapport.938c0cea.jpg";